import { CSSObject } from "@emotion/react";

export const st0: CSSObject = {
  fill: "none",
};

export const st1: CSSObject = {
  mask: "url(#mask)",
};

export const st2: CSSObject = {
  fill: "#384b5a",
};

export const st3: CSSObject = {
  fill: "#fff",
  fillRule: "evenodd",
};

export const st6: CSSObject = {
  fill: "#231f20",
};

export const st4: CSSObject = {
  fill: "#ca601d",
  fillRule: "evenodd",
};

export const st7: CSSObject = {
  fill: "url(#linear-gradient)",
};

export const st8: CSSObject = {
  isolation: "isolate",
};

export const st5: CSSObject = {
  fill: "#f58222",
  fillRule: "evenodd",
};

export const st9: CSSObject = {
  clipPath: "url(#clippath)",
};

export default {
  st0,
  st1,
  st2,
  st3,
  st4,
  st5,
  st6,
  st7,
  st8,
  st9,
};
